import React from 'react'

import styled from '@emotion/styled'

import { AlternativeOptionItem } from '../AlternativeOptionItem'

import { cssRecipeList, cssRecipeListText, cssVariantsTitle } from './styles'
import { AlternativeOptions } from '../../../model/alternativeOptions/alternativeOptions'
import { queueTrackingEvent } from '@library/tracking-integration'
import { Recipe, RecipeCoreId } from '@library/menu-service'

export type TrackVariantDisplay = {
  action: 'recipe_variant_action_sheet'
  view: string
}

type RecipeAlternativeOptionsProps = {
  currentRecipeCoreId: RecipeCoreId
  /**
   * Optional Function to be called upon switching recipes.
   */
  onChangeCheckedRecipe: (_: { previousRecipeId: RecipeCoreId; nextRecipeId: RecipeCoreId }) => void
  selectVariant: ({
    variant,
    variantOutOfStock,
  }: {
    variant: Recipe
    variantOutOfStock: boolean
  }) => void
  alternativeOptions: AlternativeOptions
  isMobile?: boolean
}

const RecipeListDiv = styled.div(cssRecipeList)
const VariantsTitle = styled.h2(cssVariantsTitle)
const RecipeListText = styled.ul(cssRecipeListText)

export function RecipeAlternativeOptions({
  currentRecipeCoreId,
  onChangeCheckedRecipe,
  selectVariant,
  alternativeOptions,
  isMobile = false,
}: RecipeAlternativeOptionsProps) {
  // alternative options include the recipe itself
  const ALTERNATIVE_OPTIONS_STARTING_LENGTH = 1

  const hasAlternativeOptions = alternativeOptions.length > ALTERNATIVE_OPTIONS_STARTING_LENGTH

  if (hasAlternativeOptions) {
    queueTrackingEvent<TrackVariantDisplay>({
      action: 'recipe_variant_action_sheet',
      view: 'grid',
    })
  }

  const preventPropagation = (e: React.SyntheticEvent) => e.stopPropagation()

  if (!hasAlternativeOptions) {
    return null
  }

  return (
    <RecipeListDiv
      role="button"
      tabIndex={-1}
      onClick={preventPropagation}
      onKeyPress={preventPropagation}
    >
      {!isMobile && <VariantsTitle>Choose an option</VariantsTitle>}

      <RecipeListText>
        {alternativeOptions.map(({ recipe, recipeName, isChecked, isOutOfStock, surcharge }) => (
          <AlternativeOptionItem
            key={recipe.coreId}
            recipeId={recipe.coreId}
            recipeName={recipeName}
            onChange={() => {
              selectVariant({ variant: recipe, variantOutOfStock: isOutOfStock })
              onChangeCheckedRecipe({
                previousRecipeId: currentRecipeCoreId,
                nextRecipeId: recipe.coreId,
              })
            }}
            isChecked={isChecked}
            isOutOfStock={isOutOfStock}
            surcharge={surcharge === undefined ? null : surcharge}
          />
        ))}
      </RecipeListText>
    </RecipeListDiv>
  )
}
